<script setup lang="ts">
import BoyIcon from '@/assets/icons/BoyIcon.vue';
import { useDisplayName } from '@/composables/useDisplayName';
import { IGenericUser } from '@/interfaces';
import { computed, toRefs } from 'vue';

const props = defineProps<{
  user: IGenericUser | null;
  theme?: 'chart' | 'default';
}>();
const { user } = toRefs(props);

const { getUserInitials } = useDisplayName();

const userInitials = computed<string | null>(() => (user.value ? getUserInitials(user.value) : null));
</script>

<template>
  <span
    class="relative size-avatar rounded-full bg-surface-tint flex items-center justify-center shrink-0 text-tint"
    :class="[theme === 'chart' && 'border-4 border-white']"
  >
    <span
      v-if="userInitials"
      class="absolute inset-0 flex items-center justify-center font-semibold text-[80%] uppercase"
    >
      {{ userInitials }}
    </span>
    <BoyIcon v-else class="size-[60%]" />
  </span>
</template>
